import React from "react";
import { invoiceDesignFontFamily } from "./InvoiceDesignSystem";

const ProcessPaymentFact = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => (
  <div className="min-w-0" style={{ fontFamily: invoiceDesignFontFamily }}>
    <dt className="text-[11.5px] font-semibold uppercase leading-[15px] tracking-[0.05em] text-[#0A0A0A]">
      {label}
    </dt>
    <dd className="mt-1.5 break-words text-[15px] font-bold leading-[19px] text-[#0A0A0A]">
      {value}
    </dd>
  </div>
);

const ProcessPaymentFacts = ({
  balanceOwing,
  billTo,
  invoiceNumber,
}: {
  balanceOwing: string;
  billTo: string;
  invoiceNumber: string;
}) => (
  <dl
    className="grid gap-4 border-b border-[#EDEFF2] pb-2.5 sm:grid-cols-3"
    data-testid="process-payment-facts"
    style={{ fontFamily: invoiceDesignFontFamily }}
  >
    <ProcessPaymentFact label="Bill To" value={billTo} />
    <ProcessPaymentFact label="Reference Invoice" value={invoiceNumber} />
    <ProcessPaymentFact label="Balance Owing" value={balanceOwing} />
  </dl>
);

export default ProcessPaymentFacts;
